import axios from "axios";
import { Auth } from "../services/authService";
const { BACKEND_URL } = require("../config/config");

const authController = new Auth();

export function getAllRequisitos() {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/requisito`;
  console.log(url);
  return axios.get(url, {
    headers: {
      Authorization: token,
    },
  });
}

export function getAllFormulariosPorRequisito(idRequisito, id_mov) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/formulariosPorRequisito/${idRequisito}/${id_mov}`;
  console.log(url);
  return axios.get(url, {
    headers: {
      Authorization: token,
    },
  });
}


export function crearRequisito(payload) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/requisito`;
  return axios.post(url, payload, {
    headers: {
      Authorization: token,
    },
  });
}

export function actualizarRequisito(idRequisito, payload) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/requisito/${idRequisito}`;

  return axios.put(url, payload, {
    headers: {
      Authorization: token,
    },
  });
}

export function eliminarRequisito(idRequisito) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/requisito/${idRequisito}`;
  return axios.delete(url, {
    headers: {
      Authorization: token,
    },
  });
}